<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="品牌名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.name" placeholder="请输入品牌名称">
						</el-input>
					</el-form-item>
				
					<el-form-item label="首字母" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.firstLetter" placeholder="请输入品牌首字母">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<!-- <el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="name" label="品牌名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="logo" label="品牌logo" align="center" >
				<template slot-scope="scope">
					<img :src="scope.row.logo" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="bigPic" label="品牌大图" align="center" >
				<template slot-scope="scope">
					<el-button @click="lookDt(scope.row.bigPic)">查看</el-button> 
				</template>
			</el-table-column>
			<el-table-column prop="sort" label="排序" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="showStatus" label="是否展示" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.showStatus==true">是</span>
					<span v-if="scope.row.showStatus==false">否</span>

				</template>
			</el-table-column>
			<el-table-column prop="factoryStatus" label="是否为品牌制造商" align="center" :show-overflow-tooltip="true">
			
				<template slot-scope="scope">
					<span v-if="scope.row.factoryStatus==true">是</span>
					<span v-if="scope.row.factoryStatus==false">否</span>
			
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="添加品牌名称" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="品牌名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.name"
							auto-complete="off" placeholder="请输入品牌名称" />
					</el-form-item>
					<el-form-item label="排序">
						<el-input type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.sort"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span id="">
								  数值越大，排序越靠前
							</span>
					</el-form-item>
					<el-form-item label="品牌首字母">
						<el-input type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.firstLetter"
							auto-complete="off" placeholder="请输入品牌首字母" />
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="品牌logo(限制一张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<span>尺寸建议（128*128px）</span>
							<el-upload :action="httpUrl1" list-type="picture-card" :on-preview="handlePictureCardPreview1"
								:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" multiple :limit="1"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
									
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="品牌大图(限制一张)" style="width: 100%;display: flex;align-items: initial;">
								<br />
								<span>尺寸建议（260*160px）</span>
								<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
									:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" multiple :limit="1"
									:on-success="onSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</div>
									
					<el-form-item label="是否展示" class="redItem">
						<el-switch v-model="storeGoodsInfo.showStatus" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="是否为品牌制造商" class="redItem">
						<el-switch v-model="storeGoodsInfo.factoryStatus" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
				
						
						<div>
							<div style="text-align: start;margin: 10px;">商品详情</div>
							<el-form-item>
								<div id="lpc-quill" class="quill">
									<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
										:before-upload="beforeAvatarUpload" :on-success="upScuccess"
										:on-error="uploadError" />
									<quill-editor v-model="storeGoodsInfo.brandStory" ref="myQuillEditor" class="editer"
										style="height: 400px;width: 700px;" :options="editorOption"
										@ready="onEditorReady($event)">
									</quill-editor>
								</div>
							</el-form-item>
						</div>
			
					<el-button type="primary" @click="submit" style="margin-top: 100px;">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					
					<el-form-item label="品牌名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.name" auto-complete="off"
							placeholder="请输入品牌名称" />
					</el-form-item>
					<el-form-item label="排序">
						<el-input type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.sort"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span>数值越大，排序越靠前</span>
					</el-form-item>
					<el-form-item label="品牌首字母">
						<el-input type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.firstLetter"
							auto-complete="off" placeholder="请输入品牌首字母" />
					</el-form-item>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<el-form-item label="品牌logo(限制一张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<el-span>尺寸建议（128*128px）</el-span></br>
				
						
					</el-form-item>
					
				</div>
				<el-upload style="text-align: left;" :action="httpUrl1" list-type="picture-card" :on-preview="handlePictureCardPreview1"
					:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" multiple :limit="1"
					:on-success="onSuccess1">
					<i class="el-icon-plus"></i>
				</el-upload>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="品牌大图(限制一张)" style="width: 100%;display: flex;align-items: initial;">
								<br />
								<span>尺寸建议（260*160px）</span>
								
								
							</el-form-item>
						</div>
				<el-upload style="text-align: left;" :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
					:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"  multiple :limit="1"
					:on-success="onSuccess">
					<i class="el-icon-plus" ></i>
				</el-upload>
					<el-form-item label="是否展示" class="redItem">
						<el-switch v-model="storeGoodsInfo.showStatus" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="是否为品牌制造商" class="redItem">
						<el-switch v-model="storeGoodsInfo.factoryStatus" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="品牌故事">
						<div>
						
							<el-form-item>
								<div id="lpc-quill" class="quill">
									<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
										:before-upload="beforeAvatarUpload" :on-success="upScuccess"
										:on-error="uploadError" />
									<quill-editor v-model="storeGoodsInfo.brandStory" ref="myQuillEditor" class="editer"
										style="height: 400px;width: 700px;" :options="editorOption"
										@ready="onEditorReady($event)">
									</quill-editor>
								</div>
							</el-form-item>
						</div>
					</el-form-item>
					<el-button type="primary" @click="submitClick" style="margin-top: 100px;">提交</el-button>

				</el-form>
				
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%"  class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				sliderlist:{},
				expressList: [],
				orderInfo: {},
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				dialogVisibleImg:false,
		
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				}
			}
		},
		methods: {
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onSuccess(response, file, fileList) {
				// console.log(file,urls,fileList)
				this.storeGoodsInfo.bigPic=file.response.message
				
			},
			onSuccess1(response, file, fileList1) {
				
				this.storeGoodsInfo.logo=file.response.message
					
			},
			handleRemove(file, fileList) {
			
					this.storeGoodsInfo.bigPic=''
		
			
			},
			handleRemove1(file, fileList) {
			
					this.storeGoodsInfo.logo=''
			
			
			},
			handlePictureCardPreview(file) {
				// console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			handlePictureCardPreview1(file) {
				// console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			lookDt(item){
			// console.log(item)
			this.dialogImageUrl = item;
			this.dialogVisibleImg = true;
			},
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {}
			},
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					 id:this.orderInfo.id,
					 firstLetter:this.orderInfo.firstLetter,
					 name:this.orderInfo.name
					// name:this.orderInfo.name
				}
				this.$api.pmsbrdselect(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.fileList = [];
				this.fileList1 = [];
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
			
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.pmsbrdadd(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.fileList = [];
				this.fileList1 = [];
				// console.log(e)
				this.$api.pmsbrdselect({id:e}).then((res) => {
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data.list[0]
						// console.log(this.storeGoodsInfo)
						this.storeGoodsInfo.showStatus = res.data.list[0].showStatus
						this.storeGoodsInfo.bigPic=res.data.list[0].bigPic
						urls=res.data.list[0].bigPic
						// console.log(urls)
						if(res.data.list[0].bigPic!=''){
							this.fileList.push({
								
								url:res.data.list[0].bigPic
							})
						}
						if(res.data.list[0].logo!=''){
							this.fileList1.push({
								
								url:res.data.list[0].logo
							})
						}
						this.dialogVisibleSwipers = true
				
					}
				})
				
			},
			// 编辑修改提交
			submitClick() {
				// console.log(urls)
				let data ={
					"id": this.storeGoodsInfo.id,
					"name": this.storeGoodsInfo.name,
					"firstLetter": this.storeGoodsInfo.firstLetter,
					"sort": this.storeGoodsInfo.sort,
					"factoryStatus": this.storeGoodsInfo.factoryStatus,
					"showStatus": this.storeGoodsInfo.showStatus,
					"logo": this.storeGoodsInfo.logo,
					"bigPic": this.storeGoodsInfo.bigPic,
					"brandStory": this.storeGoodsInfo.brandStory
				}
			
				this.$api.pmsbrdupdate(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.pmsbrdselect();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该品牌, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.pmsbrdupdeletef(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()

		}
	}
</script>

<style>

</style>
